module.exports = __webpack_public_path__ + "img/page.f5397c51.png";